<template>
  <div v-if="product.productPrice" class="price-container__items mt-2 mb-1 mr-2">
    <div class="d-flex align-items-center" :style="getPriceSize">
      <i v-if="product.is_bundle && showEditPrice && isMtd() && cartItem != undefined && itemIndex != undefined"
        class="fas fa-cog mr-2 mb-1 text-dark cursor-pointer"
        title="Edit user price"
        @click="editBundleCustomerPrice()">
      </i>
      <i v-if="!product.is_bundle && showEditPrice && isMtd() && cartItem != undefined && itemIndex != undefined"
        class="fas fa-cog mr-2 mb-1 text-dark cursor-pointer"
        title="Edit user price"
        @click="$refs[`showUserPrice${itemIndex}`].toggle()">
      </i>
      <p v-if="product.productPrice.isDiscounted" class="mb-1 mr-2 base-price font-weight-bold disabled text-secondary strikethrough on-sale" >
        {{ formatDollars(product.productPrice.regularPrice) }}
      </p>
      <p class="font-weight-bold mr-2 mb-1" :class="{'on-sale text-danger mb-1 d-flex align-items-center': product.productPrice.isDiscounted}">
        <i v-if="product.productPrice.onSale" class="fas fa-tag mr-1" title="On Sale!"></i>
        {{ formatDollars(product.productPrice.price) }}
      </p>
      <p v-if="product.productPrice.isDiscounted && product.display_savings_percent" class="badge badge-success mr-2 px-2 pt-1 mb-1">{{product.productPrice.discountPercent}}% off</p>
      <p v-if="cartItem && showEditPrice" class="mb-1 mr-2">
        <div :class="parentClasses" class="d-flex align-items-center discount-container">
          <i
            @click="toggleDiscount"
            :title="[cartItem?.product?.productPrice?.isPriceOverride ? 'Cancel discount' : 'Apply discount']"
            :class="[cartItem?.product?.productPrice?.isPriceOverride ? 'fa-times text-danger' : 'fa-dollar-sign text-success fa-lg mb-1']"
            class="fas discount-icon cursor-pointer">
          </i>
          <input
            v-show="cartItem?.product?.productPrice?.isPriceOverride" id="apply-discount" ref="applyDiscount" type="number" placeholder="$" class="form-control ml-1 px-2"
            min="0" :max="cartItem?.product?.productPrice?.regular_price" step="0.01"
            @change="applyDiscount($event, cartItem)" v-model="discountValue">
          <i
            v-if="cartItem.product.productPrice.isPriceOverride"
            @click="fixedPrice(cartItem)"
            :title="[isFixedPrice ? 'Switch off of fixed price' : 'Switch to fixed price']"
            :class="{'text-primary' : isFixedPrice}"
            class="fas fa-tags ml-2 fixed-price-icon cursor-pointer">
          </i>
        </div>
      </p>
    </div>
    <SetUserPrice
      :ref="`showUserPrice${itemIndex}`"
      :item="cartItem"
      class="mt-1 mb-2"
      @success="update" />
  </div>
</template>

<script>
  import SetUserPrice from '@/Components/Shop/SetUserPrice'

  export default {
    data() {
      return {
        discountValue: this.cartItem?.product?.productPrice?.isPriceOverride ? this.getDiscountValue() : '',
        discountForm: this.$inertia.form({ item_id: null, discount_price: null }),
        itemForm: this.$inertia.form({ item_id: null }),
        isFixedPrice: false,
      }
    },
    components: {
      SetUserPrice,
    },
    props: {
      product: Object,
      cartItem: Object,
      itemIndex: Number,
      showEditPrice: Boolean,
      priceSize: String,
      clearItemDiscountRoute: {
        type: String,
        default: route('mtd.cart.clearItemDiscount'),
      },
      setItemDiscountRoute: {
        type: String,
        default: route('mtd.cart.setItemDiscount'),
      }
    },
    computed: {
      getPriceSize() {
        if (this.priceSize) return `font-size: ${this.priceSize};`
      }
    },
    methods: {
      update() {
        this.$inertia.reload();
      },
      editBundleCustomerPrice()
      {
        let $url = this.route('catalog') + '?query=' + this.product.sku;
        window.open($url, '_blank', 'noopener, noreferrer');
      },
      getDiscountValue()
      {
        return Number(this.isFixedPrice ?
          this.cartItem.product.productPrice.price :
          this.cartItem.product.productPrice.regularPrice - this.cartItem.product.productPrice.price).toFixed(2);
      },
      toggleDiscount() {
        this.cartItem.product.productPrice.isPriceOverride = !this.cartItem.product.productPrice.isPriceOverride

        // Clear discount
        if (!this.cartItem.product.productPrice.isPriceOverride) {
          this.discountValue = ''

          this.itemForm.item_id = this.cartItem.id
          this.itemForm.post(this.clearItemDiscountRoute, {
            preserveScroll: true,
            onSuccess: () => this.$emit('onUpdate')
          })
        }
      },
      applyDiscount($event) {
        this.validateDiscount($event)
        this.discountValue = this.isFixedPrice ?
          Number($event.target.value).toFixed(2) :
          Number(this.cartItem.product.productPrice.regularPrice - $event.target.value).toFixed(2);

        this.postDiscount();
      },
      validateDiscount($event) {
        if ($event.target.value < 0) $event.target.value = 0
        if ($event.target.value > this.cartItem.product.productPrice.regularPrice) $event.target.value = this.cartItem.product.productPrice.regularPrice
      },
      fixedPrice() {
        this.isFixedPrice = !this.isFixedPrice
        if (this.isFixedPrice && this.$refs.applyDiscount.value ) {
          this.discountValue = Number(this.$refs.applyDiscount.value).toFixed(2)
        } else {
          this.discountValue = Number(this.cartItem.product.productPrice.regularPrice - this.$refs.applyDiscount.value).toFixed(2)
        }

        if (this.$refs.applyDiscount.value) 
        {
          this.postDiscount()
        }
      },
      postDiscount() {
        this.discountForm.item_id = this.cartItem.id
        this.discountForm.discount_price = this.discountValue

        this.discountForm.post(this.setItemDiscountRoute, {
          preserveScroll: true,
          onSuccess: () => this.$emit('onUpdate')
        })
      }
    },
  }
</script>

<style>
  .discount-container {
    width: 110px;
  }

  .discount-container #apply-discount {
    height: 25px;
    min-width: 69px;
    box-shadow: none;
    -moz-appearance: textfield;
  }

  .discount-container #apply-discount::-webkit-outer-spin-button,
  .discount-container #apply-discount::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>